import React from 'react';

/**
 * Card surface. `light` is the standard white card; `glass` is the frosted
 * dark panel used over the globe (command centers, stat readouts).
 */
export function Card({
  variant = 'light',
  padding = 'md',
  hover = false,
  children,
  style = {},
  ...rest
}) {
  const [hovered, setHovered] = React.useState(false);
  const pads = { none: 0, sm: 'var(--space-4)', md: 'var(--space-6)', lg: 'var(--space-8)' };

  const variants = {
    light: {
      background: 'var(--surface-card)',
      color: 'var(--text-body)',
      border: '1px solid var(--border-subtle)',
      boxShadow: hover && hovered ? 'var(--shadow-lg)' : 'var(--shadow-sm)',
    },
    glass: {
      background: 'var(--surface-glass)',
      color: 'var(--text-on-dark)',
      border: '1px solid var(--border-brand)',
      boxShadow: 'var(--shadow-glass)',
      backdropFilter: 'var(--blur-strong)',
    },
    softGlass: {
      background: 'var(--surface-glass-soft)',
      color: 'var(--text-on-dark)',
      border: '1px solid var(--border-on-dark)',
      boxShadow: 'var(--shadow-md)',
      backdropFilter: 'var(--blur-glass)',
    },
  };
  const v = variants[variant] || variants.light;

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        borderRadius: 'var(--radius-lg)',
        padding: pads[padding] ?? pads.md,
        transform: hover && hovered ? 'var(--lift-hover)' : 'none',
        transition: 'transform var(--duration-normal) var(--ease-standard), box-shadow var(--duration-normal) var(--ease-standard)',
        ...v,
        ...style,
      }}
      {...rest}
    >
      {children}
    </div>
  );
}
